<template>
  <div @click="clickLink">
    <li>
      <a class="menu-item" :class="{ active: isActive }">
        <div class="icon">
          <img :src="shop.thumbnail" alt="" />
        </div>
        <span class="text">{{ shop.name }} </span>
        <div class="dot" v-if="hasNewProducts"></div>
      </a>
    </li>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SidebarShopItem",
  props: {
    shop: {
      type: Object,
    },
  },
  data() {
    return {
      route: "",
    };
  },
  created() {
    if (this.route === "") {
      this.route = this.$router.currentRoute.path;
    }
  },
  watch: {
    $route: function (newRoute, oldRoute) {
      this.route = newRoute.path;
    },
  },
  computed: {
    ...mapGetters({
      doesShopHaveNewProducts: "shop/doesShopHaveNewProducts",
    }),
    hasNewProducts() {
      return this.doesShopHaveNewProducts(this.shop);
    },
    isActive() {
      return this.route === `/shop/${this.shop.id}`;
    },
  },
  methods: {
    clickLink() {
      this.$router.push(`/shop/${this.shop.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  padding: 3px 8px;
  .menu-item {
    border-radius: 4px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    height: 44px;
    // color: #b3b3b3;
    color: white;
    transition-timing-function: linear;
    transition-property: color;
    text-decoration: none;
    justify-content: space-between;
    &:hover {
      color: white;
      text-decoration: none;
    }
    &.active {
      // background-color: #3a3a3a;
      background-color: #2d3048;
      color: white;
      border-radius: 4px;
      padding: 0 16px;
      display: flex;
      align-items: center;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      height: 36px;
      max-height: 36px;
      width: 36px;
      max-width: 36px;
      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
        background: white;
        border-radius: 50%;
      }
    }
    .text {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: normal;
      text-transform: none;
      flex: 1;
    }
  }
}
.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: $primary1;
  margin: 0 6px;
}
</style>
